import styled from 'styled-components';

import { Box } from '../../../styles/GlobalComponents';
import { H2 } from '../../../styles/FontStyles';

const GRID_GAP = 15;
// widest the content area gets: ViewBackOffice max-width 1500 minus its 40px padding
const CONTENT_MAX_WIDTH = 1420;
// keep a card as wide as it was in the full 4-column layout
const MAX_COLUMN_WIDTH = (CONTENT_MAX_WIDTH - 3 * GRID_GAP) / 4;
// height of a populated card, so the grid keeps its size while hubs is empty:
// 40 padding + 118 title + 200 features + 17 separator + 56 price rows + 75 button
const CARD_MIN_HEIGHT = 506;

const columnCount = (hubs: number) => Math.min(hubs || 1, hubs === 5 ? 5 : 4);

export const EntryPackagesGrid = styled.div<{ hubs: number }>`
  display: grid;
  grid-template-columns: repeat(
    ${({ hubs }) => columnCount(hubs)},
    minmax(0, 1fr)
  );
  gap: ${GRID_GAP}px;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  min-height: ${CARD_MIN_HEIGHT}px;
  max-width: ${({ hubs }) =>
    columnCount(hubs) * MAX_COLUMN_WIDTH +
    (columnCount(hubs) - 1) * GRID_GAP}px;
  margin: 0 auto;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    max-width: 100%;
    min-height: auto;
    margin: 0;
  }
`;

export const GridItem = styled(Box)<{
  selected: boolean;
  image: string;
}>`
  background: url(${({ image }) => image});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 30px;
  padding: 20px;
  text-align: center;
  margin-bottom: 0;

  height: 100%;
  display: flex;
  flex-direction: column;

  > div:first-child {
    flex: 1;
  }

  @media (max-width: 1000px) {
    width: 100%;
    height: auto;
    margin-bottom: 50px;
  }
`;

export const PackageTitle = styled(H2)`
  font-size: 40px;
  line-height: 48px;
  font-weight: 800;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.45);

  @media (max-width: 800px) {
    font-size: 34px;
    line-height: 40px;
  }
`;
